export default "/img/SO.c4ac6bd21a4864947f876ca1979fd880.png";